import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var Heading = function Heading(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      contrast = _ref.contrast,
      _ref$is = _ref.is,
      Tag = _ref$is === void 0 ? 'span' : _ref$is,
      looksLike = _ref.looksLike,
      weight = _ref.weight,
      rest = _objectWithoutProperties(_ref, ["children", "className", "contrast", "is", "looksLike", "weight"]);

  if (Tag === looksLike) {
    console.debug('[TDS Heading] prop "looksLike" is only necessary if it differs from "is"');
  }

  return React.createElement(Tag, _objectSpread({
    className: cx((_cx = {}, _defineProperty(_cx, "tds-text--".concat(looksLike), looksLike), _defineProperty(_cx, "tds-text--".concat(weight), weight), _defineProperty(_cx, "tds-text--contrast-".concat(contrast), contrast), _cx), className)
  }, rest), children);
};